import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
const { addToast } = useToast();

const stripeURL = '/api/stripe';

export const fetchAvailableCountries = async () => {
    try {
        const response = await axios.get(`${stripeURL}/available_countries`);
       return response.data;
    } catch (error) {
        console.error('Error fetching available countries:', error);
        return [];
    }
}
